module.exports = __webpack_public_path__ + "img/1.85565ca9.png";